import { z } from 'zod/v4';

import { instructionResponseSchema } from './instruction-response.schema';

export const instructionV2ResponseSchema = instructionResponseSchema
  .omit({ vehicleGroupIds: true })
  .extend({
    vehicleGroups: z
      .array(
        z.object({
          id: z.number(),
          name: z.string(),
        })
      )
      .nullable(),
  });

export type InstructionV2Response = z.infer<typeof instructionV2ResponseSchema>;
